import React, { useContext, useEffect, useRef, useState } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Button,
} from "@mui/material";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Col, Row, Modal } from "react-bootstrap";
import { AiOutlineDelete, AiOutlineDownload } from "react-icons/ai";
import { IoIosAdd } from "react-icons/io";
import { AiOutlineEdit } from "react-icons/ai";
import { NavLink, useNavigate } from "react-router-dom";
import {
  updateDashboardState,
  useSelectAccess,
} from "../../../store/stateFunctions";
import { AxiosError } from "axios";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { server } from "../../../common";
import configContext from "../../../context/configContext/configContext";

const swalalert = withReactContent(Swal);

const StudentProfile = () => {
  const user = useSelectAccess("Student");
  const [profile, setProfile] = useState([]);
  const fileInputRef = useRef();
  const navigate = useNavigate();
  const [processing, setProcessing] = useState(false);
  const { setProgress } = useContext(configContext);

  const [profielphoto, setprofilephoto] = useState([]);
  const [educationModal, seteduModal] = useState(false);
  const closeEduModal = () => seteduModal(false);

  const [photoModal, setPhoto] = useState(false);
  const closePhotoModal = () => setPhoto(false);

  // const showModal = (
  //   title,
  //   callback,
  //   btn = "Save",
  //   body = null,
  //   backBtn = closeModal
  // ) => {
  //   setModal({ title, body, callback, btn, backBtn });
  // };

  const [data, setData] = useState([]);

  useEffect(() => {
    getData();
    getProfilePhoto();
  }, []);

  // Get
  const getProfilePhoto = () => {
    server
      .get("/register/getallprofile_photo", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        if (response.status === 200 || response.status === 201) {
          setprofilephoto(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  const getData = () => {
    server
      .get("/resume/getresume", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        if (response.status === 200 || response.status === 201) {
          if (response.data) {
            setData(response.data);
          }
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  useEffect(() => {
    server
      .get("/register/studentprofile", {
        headers: {
          Authorization: user.authToken,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
      .then((response) => {
        setProfile(response.data);
      })
      .catch((error) => {
        if (error.response?.status === 401) {
          navigate("/loginstudent");
        }
        console.log(
          "error",
          error.message,
          error.response?.status,
          error.response?.data,
          error
        );
      });
  }, []);

  const AddProfilePicture = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("image", fileInputRef.current.files[0]);
    try {
      if (user.profilePhotoId) {
        // If user already has a profile photo, update it
        await server.put(
          `/register/updateprofile_photo/${profielphoto.id}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: user.authToken,
            },
          }
        );
        toast.success("Profile Photo updated successfully");
      } else {
        // If user does not have a profile photo, add it
        const response = await server.post(
          "/register/addprofile_photo",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: user.authToken,
            },
          }
        );

        toast.success("Profile Photo added successfully");
      }

      // resetForm();
      closePhotoModal();
    } catch (error) {
      if (error instanceof AxiosError && error.response?.data?.message)
        toast.error(error.response.data.message);
      else if (error.response?.data?.error) {
        toast.error(error.response.data.error);
      } else {
        toast.error("Failed to connect to the server");
        console.log(error.message);
      }
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
  };

  return (
    <>
      <section style={{ backgroundColor: "#eee" }}>
        <div className="container py-5">
          <div className="row bg-light rounded-3 p-2 m-1 mb-4">
            <div className="col">
              <nav aria-label="breadcrumb" className="">
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>

                  <li className="breadcrumb-item active" aria-current="page">
                    User Profile
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4">
              <div className="card mb-4" style={{ height: "40rem" }}>
                <div className="card-body text-center">
                  {profielphoto?.map((photo) => (
                    <img
                      key={photo.id} // Use a unique key for each image if available
                      src={photo.image}
                      alt="avatar"
                      className="rounded-circle img-fluid cropped-image"
                      style={{ width: 150 }}
                    />
                  ))}
                  <h5 className="my-3">{profile.name}</h5>
                  <a href="">{profile.email}</a>

                  <div className="d-flex justify-content-center my-4">
                    <button
                      size="sm"
                      className="banner rounded-3 ms-2 p-2 text-white border-0"
                      onClick={() => setPhoto(true)}
                    >
                      Profile Photo
                    </button>
                    <button
                      size="sm"
                      className="banner rounded-3 ms-2 p-2 text-white border-0"
                    >
                      <NavLink
                        to="/studentprofile/editprofile"
                        className="text-white"
                      >
                        Edit Profile
                      </NavLink>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="card mb-4" style={{ height: "40rem" }}>
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-3">
                      <p className="mb-0">Current Address </p>
                    </div>
                    <div className="col-sm-9">
                      <p className="text-muted mb-0">
                        {profile.current_address}
                      </p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <p className="mb-0">Permanent Address</p>
                    </div>
                    <div className="col-sm-9">
                      <p className="text-muted mb-0">
                        {profile.permanent_address}
                      </p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <p className="mb-0">Occupation</p>
                    </div>
                    <div className="col-sm-9">
                      <p className="text-muted mb-0">{profile.occupation}</p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <p className="mb-0">Organization Name</p>
                    </div>
                    <div className="col-sm-9">
                      <p className="text-muted mb-0">
                        {profile.organization_name}
                      </p>
                    </div>
                  </div>
                  <hr />{" "}
                  <div className="row">
                    <div className="col-sm-3">
                      <p className="mb-0">Blood Group</p>
                    </div>
                    <div className="col-sm-9">
                      <p className="text-muted mb-0">{profile.blood_group}</p>
                    </div>
                  </div>
                  <hr />{" "}
                  <div className="row">
                    <div className="col-sm-3">
                      <p className="mb-0">Gender</p>
                    </div>
                    <div className="col-sm-9">
                      <p className="text-muted mb-0">{profile.gender}</p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <p className="mb-0">Employeed</p>
                    </div>
                    <div className="col-sm-9">
                      <p className="text-muted mb-0">{profile.employed}</p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <p className="mb-0">Village</p>
                    </div>
                    <div className="col-sm-9">
                      <p className="text-muted mb-0">{profile.village}</p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <p className="mb-0">Taluka</p>
                    </div>
                    <div className="col-sm-9">
                      <p className="text-muted mb-0">{profile.taluka}</p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <p className="mb-0">District</p>
                    </div>
                    <div className="col-sm-9">
                      <p className="text-muted mb-0">{profile.district}</p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <p className="mb-0">State</p>
                    </div>
                    <div className="col-sm-9">
                      <p className="text-muted mb-0">{profile.state}</p>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Modal show={photoModal} onHide={closePhotoModal}>
        <Modal.Header>
          <Modal.Title>
            <h5>Upload Your Profile Photo</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={(e) => AddProfilePicture(e, user)}>
            <div className="form-outline mb-2">
              <input
                name="org_image"
                margin="dense"
                type="file"
                className="form-control"
                onChange={handleFileChange}
                ref={fileInputRef}
                fullWidth
                required
              />
            </div>
            <Button variant="contained" className="ms-2" type="submit">
              Upload
            </Button>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default StudentProfile;
